import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Deep-clones every HTTP response body so that objects coming from
 * TransferState (SSR cache) or NgRx are always mutable.
 *
 * Angular 18 freezes TransferState objects during hydration, causing
 * "Cannot assign to read only property" and "object is not extensible"
 * errors when services try to mutate API response data directly.
 */
@Injectable()
export class DeepCloneInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse && event.body != null) {
                    return event.clone({ body: structuredClone(event.body) });
                }
                return event;
            })
        );
    }
}
